import { getPathString } from '@/factories/create-router-factory'

import type { BetaGroup, BetaPage } from './beta.types'

// Note: same order as the main header menu
const BETA_GROUP_ORDER: BetaGroup[] = ['contacts', 'operations', 'adminSettings']

// Note: the app uses a hash router, so the shareable URL is the current origin + base path with
// the route after '#' - this keeps it correct on local, staging, pre-prod and production.
export const getBetaPageUrl = (to: BetaPage['to']) =>
  `${window.location.origin}${window.location.pathname}#${getPathString(to)}`

export const groupBetaPages = (pages: BetaPage[]) =>
  BETA_GROUP_ORDER.map((group) => ({
    group,
    pages: pages.filter((page) => page.group === group),
  })).filter(({ pages: groupPages }) => groupPages.length > 0)
